import { Pagination } from "antd";
import styled from "styled-components";
import {
  formatListPageSizeOption,
  LIST_PAGE_SIZE_OPTIONS,
} from "../../utils/listPageSizePreference";

/** @param {number} total @param {[number, number]} range */
export const formatListBoardResultsTotal = (total, range) =>
  `Results ${range[0]}-${range[1]} of ${total}`;

/**
 * Shared list/board footer pagination — results count left, controls right.
 * @param {Object} props
 * @param {number} props.current
 * @param {number} props.total
 * @param {number} props.pageSize
 * @param {(page: number, size: number) => void} props.onChange
 * @param {boolean} [props.disabled]
 */
/**
 * Ant Design's pagination size menu labels options as "N / page" and does not
 * forward a custom label builder. Supply the select options directly so All
 * stays readable.
 * @param {number} pageSize
 * @return {{ value: number, label: string }[]}
 */
const pageSizeSelectOptions = pageSize => {
  const numericSize = Number(pageSize);
  const values = LIST_PAGE_SIZE_OPTIONS.includes(numericSize)
    ? LIST_PAGE_SIZE_OPTIONS
    : [...LIST_PAGE_SIZE_OPTIONS, numericSize]
        .filter(value => Number.isFinite(value) && value > 0)
        .sort((left, right) => left - right);

  return values.map(value => ({
    value,
    label: formatListPageSizeOption(value),
  }));
};

export function ListBoardPagination({ current, total, pageSize, onChange, disabled = false }) {
  return (
    <ListBoardPaginationFooter className="antPagination">
      <Pagination
        current={current}
        total={total}
        showSizeChanger={{ options: pageSizeSelectOptions(pageSize) }}
        showQuickJumper
        pageSize={pageSize}
        pageSizeOptions={LIST_PAGE_SIZE_OPTIONS}
        onChange={onChange}
        disabled={disabled}
        showTotal={formatListBoardResultsTotal}
      />
    </ListBoardPaginationFooter>
  );
}

const ListBoardPaginationFooter = styled.div`
  padding: 10px 24px;
  width: 100%;
  background-color: #fff;
  flex-shrink: 0;

  .css-dev-only-do-not-override-5uvb3z.ant-pagination,
  .ant-pagination {
    color: var(--GREY, #4a4a68);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0.36px;

    .ant-pagination-item,
    .ant-pagination-options-quick-jumper,
    .ant-select-selection-item,
    .ant-select-item-option-content {
      color: var(--GREY, #4a4a68);
      text-align: center;
      font-family: Inter;
      font-feature-settings:
        "liga" off,
        "clig" off;
      font-size: 14px;
      font-weight: 600;
    }

    .ant-select-selector {
      cursor: pointer;
    }

    .ant-pagination-item-active {
      border-color: transparent;
      color: var(--Primary-Blue, #2060ea);
    }
  }

  .ant-pagination {
    position: relative;
    justify-content: flex-end;

    .ant-pagination-total-text {
      position: absolute;
      left: 0;
    }
  }
`;
